import { Action, createReducer, on } from "@ngrx/store";
import { OnboardingState } from "../state/onboarding.state";
import { EhsResponse, SupplierAddress, SupplierBank } from "../../models/supplier.model";
import { CompleteRegistration, FormTemplate, OnboardingTab } from "../../models/onboarding.model";
import { SupplierTaxInfo } from "../../models/tax.model";
import * as OnboardingActions from '../actions/onboarding.actions';

//  Initial value of the onboarding state
const initialValue: OnboardingState = {
    currentSupplierCode: '',
    supplierType: '',
    supplierCategory: null,
    supplierCodes: [],
    regionCode: '',
    errorMessage: null,
    supplierAddress: new SupplierAddress(),
    supplierContacts: [],
    supplierBank: new SupplierBank(),
    supplierTax: new SupplierTaxInfo(),
    documentInfo: null,
    completeRegistration: new CompleteRegistration(),
    completedTabs: [],
    rejectedTabs: [],
    receivedOnboardingStepsState: false,
    currentTab: OnboardingTab.Home,
    nextAvailableTab: OnboardingTab.ADDRESS,
    currentTabStatus: '',
    vendorCountry: '',
    isClmEnabled: false,
    requiredOnboardingSteps: [],
    currentTabRejection: null,
    supplierDetails: {
        LegalName: '',
        DBAName: ''
    },
    trainingDocs: {
        extended: [],
        initial: [],
    },
    ehsResponse: new EhsResponse()
};

/**
 * Reducer for the onboarding state
 */
const _onboardingReducer = createReducer<OnboardingState>(
    initialValue,
    on(OnboardingActions.SetCurrentSupplierCode, (state, action): OnboardingState => {
        return {
            ...state,
            currentSupplierCode: action.supplierCode
        };
    }),
    on(OnboardingActions.SetSupplierType, (state, action): OnboardingState => {
        return {
            ...state,
            supplierType: action.supplierType
        }
    }),
    on(OnboardingActions.SetSupplierCategory, (state, action): OnboardingState => {
        return {
            ...state,
            supplierCategory: action.supplierCategory
        }
    }),
    on(OnboardingActions.SetVendorCountry, (state, action): OnboardingState => {
        return {
            ...state,
            vendorCountry: action.vendorCountry
        }
    }),
    on(OnboardingActions.SetSupplierCodes, (state, action): OnboardingState => {
        return {
            ...state,
            supplierCodes: [...action.supplierCodes]
        }
    }),
    on(OnboardingActions.SetErrorMessage, (state, action): OnboardingState => {
        return {
            ...state,
            errorMessage: action.errorMessage
        };
    }),
    on(OnboardingActions.SetSupplierDetails, (state, action): OnboardingState => {
        return {
            ...state,
            errorMessage: '',
            supplierDetails: {
                LegalName: action.supplierLegalName,
                DBAName: action.supplierDbaName
            }
        };
    }),
    on(OnboardingActions.SetSupplierAddress, (state, action): OnboardingState => {
        return {
            ...state,
            errorMessage: '',
            supplierAddress: action.supplierAddress,
        };
    }),
    on(OnboardingActions.SetOnboardingClmFlag, (state, action): OnboardingState => {
        return {
            ...state,
            isClmEnabled: action.flag
        }
    }),
    on(OnboardingActions.SetSupplierContacts, (state, action): OnboardingState => {
        return {
            ...state,
            supplierContacts: action.contacts
        }
    }),
    on(OnboardingActions.SetSupplierBank, (state, action): OnboardingState => {
        return {
            ...state,
            supplierBank: action.supplierBank
        }
    }),
    on(OnboardingActions.SetSupplierTax, (state, action): OnboardingState => {
        return {
            ...state,
            supplierTax: action.supplierTax
        }
    }),
    on(OnboardingActions.SetCompleteRegistration, (state, action): OnboardingState => {
        return {
            ...state,
            completeRegistration: action.completeRegistration
        }
    }),
    on(OnboardingActions.SetRegionCode, (state, action): OnboardingState => {
        return {
            ...state,
            regionCode: action.regionCode
        }
    }),
    on(OnboardingActions.SetDocumentInformation, (state, action): OnboardingState => {
        return {
            ...state,
            documentInfo: action.documentInfo
        }
    }),
    on(OnboardingActions.GetOnboardingTrainingDocumentsSuccess, (state, action): OnboardingState => {
        const trainingDocs = {...state.trainingDocs};
        trainingDocs[action.onboardingType] = action.documents;
        return {
            ...state,
            trainingDocs
        }
    }),
    on(OnboardingActions.SetEhsQuestionnaireResponse, (state, action): OnboardingState => {
        return {
            ...state,
            ehsResponse : action.response,
        };
    }),
);

// You need to wrap your reducer as function call like this:
export function OnboardingReducer(state: OnboardingState | undefined, action: Action) {
    return _onboardingReducer(state, action);
}